import React from 'react';
import * as Styled from './styled';

const ErrorMessage: React.FC<{ title: string; children: React.ReactNode }> = ({ title, children }) => {
  return (
    <Styled.Wrapper>
      <Styled.ErrorMessage>
        <Styled.Title>{title}</Styled.Title>
        <Styled.Message>{children}</Styled.Message>
      </Styled.ErrorMessage>
    </Styled.Wrapper>
  );
};

export default ErrorMessage;
